import React, {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';

import _ from 'lodash';
import { isBlank } from 'utils/object';
import { BiddingState, getFormItemList } from './utils';
import './index.less';
import { OptionsContext } from '../DetailLayout/context';
import { FormMode, transformBlobidsToFileList } from '../../utils';
import { CommonForm } from 'containers/OutBidding/components/CommonForm';
import { NodeEnum } from 'containers/OutBidding/utils';

const InitFormData: Record<string, any> = {};

const EvaluationForm = forwardRef((props: any, ref: any) => {
  const { prefixCls = 'bidding-evaluation-form', detail = {}, editFields = [], structured } = props;

  const isEdit = !isBlank(detail);

  const [formData, setFormData] = useState(InitFormData);
  const formRef = useRef<any>();
  const optionsMap = useContext(OptionsContext);

  // 初始化数据（detail.id 变化时重新初始化，修复跨单据缓存问题）
  useEffect(() => {
    if (!isBlank(detail)) {
      const { bidding_suppliers = [], state } = detail;
      const [curSupplier = {}] = bidding_suppliers;
      const { bidding_supplier_quotes = [], bidding_state } = curSupplier;
      const [curQuoteInfo = {}] = bidding_supplier_quotes;
      const {
        tender_plan_attachment_dtos = [],
        currency: quote_currency = 'rmb',
        quote_price,
        quote_price_attachment_dtos = [],
      } = curQuoteInfo;

      let isWin;
      if (state === NodeEnum.CLOSED) {
        if (bidding_state === BiddingState.BIDDING_WIN) {
          isWin = true;
        } else {
          isWin = false;
        }
      }

      setFormData({
        tender_plan_attach_blob_ids: transformBlobidsToFileList(
          tender_plan_attachment_dtos
        ),
        quote_currency: quote_currency.toLowerCase(),
        quote_price,
        is_win: isWin,
        quote_price_attach_blob_ids: transformBlobidsToFileList(
          quote_price_attachment_dtos
        ),
        bidding_suppliers,
      });
    }
  }, [detail.id]);

  // 对外暴露方法
  useImperativeHandle(ref, () => ({
    validData() {
      if (!(formRef.current && formRef.current.valid())) {
        return false;
      }
      return formData;
    },
  }));

  // 动态渲染 formItem 组件
  const itemList = getFormItemList({
    formData,
    optionsMap,
    setFormData,
    editFields,
    detail,
    structured,
  });

  const commonFormProps = {
    formProps: { isLabelVertical: true },
    formItemList: itemList,
  };

  return (
    <div className={prefixCls}>
      {/* Form 组件只有 edit 模式，才会启用非空校验 */}
      <CommonForm
        {...commonFormProps}
        ref={formRef}
        mode={editFields.length ? FormMode.Edit : FormMode.Show}
      />
    </div>
  );
});

export default EvaluationForm;
